import React, { useEffect, useState } from "react";
import "../Coporate-travel-management/CorporateBanner/CorporateBanner.css";
import BannerWrapper from "../../commonComponents/BannerWrapper";
import HeadingH1 from "../../utls/HeadingH1";
const StrategicManagementBanner = ({ onLoad }) => {
   const [useHighRes, setUseHighRes] = useState(false);
    const [imageLoaded, setImageLoaded] = useState(false);
      // Check network speed and update state accordingly.
      useEffect(() => {
        if (navigator.connection) {
          const connection = navigator.connection;
          // You can adjust the threshold as needed.
          if (connection.downlink && connection.downlink > 2) {
            setUseHighRes(true);
          }
        } else {
          // If navigator.connection is not available, assume a fast connection.
          setUseHighRes(true);
        }
      }, []);
    
      // Immediately unlock the rest of the page as soon as the banner mounts after delay of 0.5s.
      useEffect(() => {
        if (!useHighRes && onLoad) {
          const timer = setTimeout(() => {
            onLoad();
          }, 500);
          return () => clearTimeout(timer);
        }
      }, [useHighRes, onLoad]);
    
      // Callback for when the index 0 image loads on high-speed connections.
      const handleImageLoad = () => {
        if (useHighRes) {
          setImageLoaded(true);
          if (onLoad) {
            onLoad();
          }
        }
      };
  const bannerImage =
    "https://blueberrywebsites.azureedge.net/BBT/New%20Banners%20all%20pages/New%20DesignBanners%20BBT/Strategic%20account%20management.webp";

  useEffect(() => {
    // Preload the image to prevent flickering
    const img = new Image();
    img.src = bannerImage;
  }, []);

  return (
    <BannerWrapper onLoad={onLoad}>
    {({ useHighRes, imageLoaded, handleImageLoad }) => (
      <div
        className="container-fluid ctm-banner position-relative p-0"
        style={useHighRes && !imageLoaded ? { minHeight: 0 } : {}}
      >
      <img
            src="https://blueberrywebsites.azureedge.net/BBT/New%20Banners%20all%20pages/New%20DesignBanners%20BBT/17.%20Business%20Travel.webp"
            alt="Contact Banner"
            className="w-100"
            // For high-speed, use eager loading; for low-speed, lazy loading.
            loading={useHighRes ? "eager" : "lazy"}
            // Attach the onLoad handler only for high-speed connections.
            onLoad={useHighRes ? handleImageLoad : undefined}
            fetchpriority={useHighRes ? "high" : "auto"}
          />
         {imageLoaded &&
      <div className="ctm-text position-absolute text-white  mt-3 pt-xxl-4">
        <p className="fs4 text-uppercase busy grotesk-headings">
          STRATEGIC ACCOUNT MANAGEMENT
        </p>
        <HeadingH1 className="headings.custom-headingw-75">
          Efficient Travel, Exceptional Results
        </HeadingH1>
        <div className="d-flex common-second-content">
          <div className="ornge-border"></div>
          <div className="second-content">
            Is your travel program driving results? We create customized travel
            solutions that optimize efficiency and reduce costs, ensuring
            exceptional outcomes for your business.
          </div>
        </div>
      </div>
}
    </div>
     )}
    </BannerWrapper>
  );
};

export default StrategicManagementBanner;
